export const SDK_VERSION = '7.106.0';
